// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"45":"30e1f94b","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"45":"4970cc62ba1237e66bec","245":"0f0179df1da8e7f9cbf0","453":"603eec11b06438395241"}[chunkId] + ".js";
};